import { styled, alpha } from "@mui/material/styles";
import * as React from "react";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const CssSelect = styled(Autocomplete)(({ theme }) => ({
  color: "white",

  borderRadius: "4px",
  "& .MuiInputLabel-outlined": {
    color: "white",
    fontFamily: "Noto Sans JP, Meiryo, -apple-system", // フォントを指定
  },
  "& .MuiAutocomplete-inputRoot": {
    color: "white",
    fontFamily: "Noto Sans JP, Meiryo, -apple-system", // フォントを指定
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-focused": {
    color: "white",
    borderColor: "rgba(228, 219, 233, 0.25)",
    borderWidth: "0px",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    color: "white",
    borderColor: "rgba(228, 219, 233, 0.25)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderRadius: "4px",
    border: "1px solid white  !important",
  },
  ".MuiSvgIcon-root ": {
    fill: "white !important",
  },
  "&:hover": {
    color: "white",
    backgroundColor: alpha(theme.palette.common.white, 0.25),
    borderRadius: "4px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "white",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    color: "white",
    borderColor: "rgba(228, 219, 233, 0.25)",
    border: "1px solid",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid",
    borderColor: "white",
  },
}));

export function DataJacketAutocomplete({
  index,
  handleSelectOnChange,
  currentList,
}) {
  const [value, setValue] = React.useState({});
  React.useEffect(() => {
    if (value !== null && "" !== value.name && "" !== value.id) {
      handleSelectOnChange(index, value.name, value.id);
    } else {
      handleSelectOnChange(index, "", "");
    }
  }, [value]);
  return (
    <Grid
      item
      xs={12}
      style={{
        color: "white",
        alignItems: "center",
      }}
    >
      <FormControl
        style={{
          backgroundColor: "#303234",
          color: "white",
          width: "98%",
          borderRadius: "4px",
        }}
      >
        <CssSelect
          disablePortal
          options={currentList}
          style={{ width: "100%" }}
          getOptionLabel={(option) => option.label || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              label={"データジャケット起点" + String(index)}
            />
          )}
          labelid={"dataJacketLabel" + String(index)}
          id={"dataJacketIndexId" + String(index)}
          label={"データジャケット起点" + String(index)}
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        ></CssSelect>
      </FormControl>
    </Grid>
  );
}
